module.exports = __webpack_public_path__ + "img/graphit.b41a3820.png";